let API_URL = "http://localhost:5000"; // default for local dev

if (process.env.NODE_ENV === "production") {
  API_URL = "https://api.streamwest.wamoody.com"; 
}

export default API_URL;